module.exports = __webpack_public_path__ + "img/cintes-tramades.3167c546.jpg";